<!--
 * @Author: your name
 * @Date: 2020-06-08 16:19:49
 * @LastEditTime: 2022-07-27 15:47:23
 * @LastEditors: 李嘉辉 LiJiaHui0908
 * @Description: In User Settings Edit
 * @FilePath: /xingmahui_front/src/views/common/newMessage/message.vue
-->
<template>
  <div>
    <keep-alive :include="includes" :max="5">
      <div class="wrap">
        <div class="goBack" @click="goBack">
          <van-icon name="arrow-left"/>
        </div>
        <div v-if="showLikeNumber" class="unread unread-like">
          <p v-cloak>{{ countLikeNumber > 99 ? '99' : countLikeNumber }}</p>
        </div>
        <van-tabs v-model="active" type="card" @click="checkView">
          <van-tab class="tab1_list" title="回复">
            <van-list
                v-if="hideContent"
                v-model="replyListLoading"
                :error.sync="replyListError"
                :finished="replyListFinished"
                :finished-text="likeFnishText"
                class="vanlist"
                error-text="请求失败，点击重新加载"
                @load="getReplyList()"
            >
              <div
                  v-for="(item, index) in replyList"
                  :key="index"
                  class="replyList"
              >
                <div
                    class="top"
                    @click="
                    toCommentDetails(
                      item,
                      item.carrierId,
                      item.id,
                      item.carrierSpecificId,
                      '1',
                      item.replyDelete,
                      item.pid,
                      item.crmId
                    )
                  "
                >
                  <span
                      v-lazy:background-image="
                      item.crmId != '0' ? item.headImg : gmHeadImg
                    "
                      class="avatar"
                  >
                    <div v-if="item.readState == 0" class="cir"></div>
                  </span>
                  <div class="name">
                    {{ item.nickName }}
                    <span style="padding-left:9px">回复了您的评论</span>
                    <span style="float: right;">{{ item.time }}</span>
                  </div>
                  <span v-if="item.replyDelete == 0" class="comment">
                    | {{ item.contents }}
                  </span>

                  <div v-else class="comment" style="color:#999999;">
                    | 评论已删除
                  </div>
                </div>
                <div v-if="item.isDelete == 0" class="content">
                  {{ item.replyContent }}
                </div>
                <div v-else class="content" style="color:#999999;">
                  评论已删除
                </div>

                <div
                    v-if="item.title != null"
                    class="bottom"
                    @click="
                    toComment(item.carrierId, item.carrierSpecificId, item.id)
                  "
                >
                  <div class="title">
                    <span v-if="item.carrierId == 2">{{ item.tagName }}</span>
                    <!-- TODO:2022年12月26日第一期特殊处理 -->
                    <!-- <div v-html="item.title"></div> -->
                    {{ item.title }}
                  </div>
                </div>
                <div
                    v-else
                    class="bottom"
                    @click="
                    toReleteComment(
                      item.carrierId,
                      item.carrierSpecificId,
                      item.id
                    )
                  "
                >
                  <div class="title">
                    <span
                        v-if="item.carrierId == 2"
                        style="color:#999999;border:none"
                    >| 抱歉，此文章已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 1"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 10"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 7"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 5"
                        style="color:#999999;border:none"
                    >| 抱歉，此音频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 6"
                        style="color:#999999;border:none"
                    >| 抱歉，此音频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == 4"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                  </div>
                </div>
                <div class="replyCom">
                  <div v-if="item.isDelete == 0 || item.replyDelete == 0">
                    <span
                        @click="
                        like(
                          item.carrierId,
                          item.carrierSpecificId,
                          item.id,
                          index,
                          item.pid,
                          item.crmId
                        )
                      "
                    >
                      <van-icon
                          v-if="!item.isLike"
                          color="#999"
                          name="good-job-o"
                      />
                      <van-icon v-else color="#D7AB3A" name="good-job"/>
                    </span>
                    <span @click="replyComment(item)">
                      <img alt src="../../../assets/images/baby/icon1.png"/>
                    </span>
                  </div>
                </div>
              </div>
            </van-list>
            <div v-else class="noContent">
              <img alt src="../../../assets/images/message/xiaohe.png"/>
              <p>还没有信息...</p>
            </div>
          </van-tab>
          <!-- 点赞列表 -->
          <van-tab class="tab2_list" title="赞">
            <van-list
                v-if="hideContents"
                v-model="likeListLoading"
                :error.sync="likeListError"
                :finished="likeListFinished"
                :finished-text="likeFnishText"
                class="vanlist"
                error-text="请求失败，点击重新加载"
                @load="getLikeList()"
            >
              <div
                  v-for="(item, index) in likeList"
                  :key="index"
                  class="praiseList"
              >
                <div
                    class="top"
                    @click="
                    toCommentDetails(
                      item,
                      item.carrierId,
                      item.id,
                      item.carrierSpecificId,
                      '2',
                      item.isDelete,
                      item.parentId,
                      item.commentCrm
                    )
                  "
                >
                  <span v-lazy:background-image="item.headImg" class="avatar">
                    <div v-if="item.isRead == false" class="cir"></div>
                  </span>
                  <div class="name">
                    {{ item.nickName }}
                    <span style="padding-left:9px">赞了您的评论</span>
                    <span style="float: right;">{{ item.createTime }}</span>
                  </div>
                  <div v-if="item.isDelete == 0" class="comment">
                    | {{ item.contents }}
                  </div>
                  <div v-else class="comment" style="color:#999999;">
                    | 评论已删除
                  </div>
                </div>
                <div
                    v-if="item.titleName != null"
                    class="bottom"
                    @click="
                    toComment(item.carrierId, item.carrierSpecificId, item.id)
                  "
                >
                  <div class="title">
                    <!-- <span v-if="item.carrierId == 2">{{ item.tagName }}</span> -->
                    {{ item.titleName }}
                  </div>
                </div>
                <div v-else class="bottom">
                  <div class="title">
                    <span
                        v-if="item.carrierId == '1'"
                        style="color:#999999;border:none"
                    >抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '2'"
                        style="color:#999999;border:none"
                    >抱歉，此文章已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '10'"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '7'"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '5'"
                        style="color:#999999;border:none"
                    >| 抱歉，此音频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '6'"
                        style="color:#999999;border:none"
                    >| 抱歉，此音频已被删除</span
                    >
                    <span
                        v-else-if="item.carrierId == '4'"
                        style="color:#999999;border:none"
                    >| 抱歉，此视频已被删除</span
                    >
                  </div>
                </div>
                <div class="box"></div>
              </div>
            </van-list>
            <div v-else class="noContent">
              <img alt src="../../../assets/images/message/xiaohe.png"/>
              <p>还没有信息...</p>
            </div>
          </van-tab>
        </van-tabs>
        <div
            v-if="isFocus"
            class="centerComment"
            @click="isBlur()"
            @touchmove.prevent
            @mousewheel.prevent
        >
          <div class="mask" @click="isBlur('1')"></div>
          <div class="fieldWrap">
            <div class="fieldCon">
              <van-cell-group class="input-item">
                <van-field
                    v-model="message"
                    :placeholder="'回复：' + replyUserInfo.nickName"
                    autofocus
                    autosize
                    maxlength="200"
                    rows="10"
                    type="textarea"
                    @input="inputChange"
                />
              </van-cell-group>
            </div>
            <div class="fieldTop">
              <!-- <span class="close" @click="isBlur('1')">
              <img src="./../../assets/images/activity/harvard/close.png" alt />
            </span> -->
              <!-- <span class="title">回复：{{replyUserInfo.nickName}}</span> -->
              <span
                  class="button"
                  @click="message.length > 0 ? submitAllComment() : ''"
              >提交</span
              >
            </div>
          </div>
        </div>
        <foodVedio
            ref="childVideo"
            :showVedio="showVedio"
            :videoDetail="dataInfo"
            :videoId="dataInfo.id"
            isHfindex="true"
            @hideVedio="hidevedioEvent"
        />
      </div>
    </keep-alive>
  </div>
</template>

<script>
import API from '@/utils/axiosApi/messageApi'
import {Dialog} from 'vant'
import {Debounce, getCookie, getHeadImgAndName, getmotherState, getUserInfo, setCookie,} from '@/assets/js/common.js'
import {setTimeout} from 'timers'
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue' //京城视频
import {mapState} from 'vuex'

export default {
  name: 'messages',
  components: {foodVedio},
  data() {
    return {
      dataInfo: {}, //名医视频数据
      playStatus: false,
      showVedio: false,
      active: 0, //tab默认为第一个标签
      avatar: require('./../../../assets/images/home/ikon1.png'),
      isFocus: false,
      showLikeNumber: false,
      replyListLoading: false,
      replyListFinished: false,
      replyListError: false,
      replyFnishText: '',
      pageParams: {
        page: 1,
        size: 25,
      },
      likeListLoading: false,
      likeListFinished: false,
      likeListError: false,
      hideContent: true,
      hideContents: true,
      likeFnishText: '',
      pagesParams: {
        page: 1,
        size: 25,
      },
      switchTagId: 0,
      likeState: '', //点赞状态开关
      message: '',
      isLikes: false,
      userInfo: [],
      replyList: [], //回复列表
      likeList: [], //点赞列表
      replyUserInfo: [], //当前回复人的信息
      countLikeNumber: '', //点赞未读数
      replyNumber: '', //未回复数
      tabState: false,
      gmHeadImg: require('./../../../assets/images/home/gmHeadImg.png'),
      flag: true,
    }
  },
  computed: {
    ...mapState({
      includes: (state) => state.includes,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getUserName()
      vm.$store.commit('changeIncludes', ['messages'])
      // if (
      //   !vm.getCookie("xmh_nickname") ||
      //   vm.getCookie("xmh_nickname") == "" ||
      //   !vm.getCookie("xmh_headimgurl") ||
      //   vm.getCookie("xmh_headimgurl") == ""
      // ) {
      //   vm.$http.get(
      //     "/wechat/getUserInfoByOpenId",
      //     { openId: vm.getCookie("xmh_openid") },
      //     res => {
      //       if (res.code === "200") {
      //         document.cookie = `xmh_headimgurl=${res.data.headimgurl}`;
      //         document.cookie = "xmh_nickname=" + escape(res.data.nickname);
      //       }
      //     }
      //   );
      // }
    })
  },
  beforeCreate() {
    // document.querySelector("body").setAttribute("style", "background:#fff");
  },
  mounted() {
    var shareDataParams = {
      shareLink: this.$http.hostName + '/home',
      shareDesc: '1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。',
      shareTitle: '星妈会',
      imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
    }
    this.wxJsSet.wxShare('fx', shareDataParams, this)
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  created() {
    // console.log(this.replyNumber)
    // console.log(this.countLikeNumber)
    // if (this.replyNumber == 12 && this.countLikeNumber != 0) {
    //   this.active = 1;
    // }
  },
  methods: {
    getCookie,
    setCookie,
    getmotherState,
    getUserInfo,
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie('xmh_headimgurl', headImgurl, 365)
        this.setCookie('xmh_nickname', nickName, 365)
      } catch (err) {
      }
    },
    // 名医视频获取详情
    getDoctorDetail(item) {
      let newItem = JSON.parse(JSON.stringify(item))
      const {code} = this.getmotherState()
      this.$http.post(
          '/capital/details',
          {},
          {id: newItem, crmId: this.getUserInfo(), memberLevelCode: code},
          (res) => {
            if (res.code === '200') {
              console.log(res)
              if (!res.data) {
                this.$toast('课程已下架')
                return false
              }
              this.dataInfo = res.data
              this.playVedio()
            }
          },
          null,
          'lucky'
      )
    },
    playVedio() {
      this.playStatus = !this.playStatus
      if (this.playStatus) {
        this.showVedio = true
      }
    },
    // 视频播放返回按钮
    hidevedioEvent() {
      this.showVedio = false
      this.playStatus = false
    },
    //跳转回复详情
    toCommentDetails(
        item,
        carrierId,
        ids,
        carrierSpecificId,
        article,
        replyDelete,
        pid,
        crmId
    ) {
      if (carrierId == 12 && article == 1) {
        this.replyComment(item)
        console.log('跳转回复详情', article)
      } else if (carrierId == 12 && article == 2) {
        this.isBlur()
        console.log('跳转回复详情', article)
      } else {
        console.log('跳转回复详情', article)
        // 文章删除时不执行下面操作
        if (replyDelete == 1) {
          return
        }
        //article 1为回复列表  2位点赞列表 用以区分更新tab未读状态
        if (article == 1) {
          this.getReplyState(ids, crmId)
          // this.getReplyList();
          gio('track', 'informpage_checkcomment')
        } else {
          this.getNewsState(ids, crmId)
          // this.getLikeList();
          gio('track', 'informpage_checklike')
        }
        var that = this
        console.log(
            {
              type: carrierId,
              carrierSpecificId: carrierSpecificId,
              first: pid,
            },
            '跳转参数'
        )
        setTimeout(function () {
          that.$router.push({
            path: '/replyComment',
            query: {
              type: carrierId,
              carrierSpecificId: carrierSpecificId,
              first: pid,
            },
          })
        }, 200)

        // if (carrierId == 1) {
        //   //1哈佛课堂
        //   this.$router.push({
        //     path: "/replyComment/" + carrierSpecificId,
        //     query: {
        //       carrierId: carrierId,
        //       id: ids,
        //       carrierSpecificId: carrierSpecificId
        //     }
        //   });
        // } else {
        //   this.$router.push({
        //     //2奶妈百科
        //     path: "/baby/detail/" + carrierSpecificId
        //   });
        // }
      }
    },
    toReleteComment(carrierId, carrierSpecificId, id) {
      if (
          carrierId == 1 ||
          carrierId == 10 ||
          carrierId == 7 ||
          carrierId == 4
      ) {
        Dialog({message: '抱歉，此视频已被删除'})
      } else if (carrierId == 5 || carrierId == 6) {
        Dialog({message: '抱歉，此音频已被删除'})
      } else if (carrierId == 2) {
        Dialog({message: '抱歉，此文章已被删除'})
      }
    },
    // 跳转文章页
    toComment(carrierId, carrierSpecificId, id) {
      if (this.active == '0') {
        this.getReplyState(id)
        // if (carrierId == 1) {
        //   this.$router.push({
        //     //1哈佛课堂
        //     path: "/harvard/" + carrierSpecificId
        //   });
        // } else {
        //   this.$router.push({
        //     //2奶妈百科
        //     path: "/baby/detail/" + carrierSpecificId
        //   });
        // }
      } else if (this.active == '1') {
        this.getNewsState(id, this.userInfo.crm_id)
        // if (carrierId == 1) {
        //   this.$router.push({
        //     //1哈佛课堂
        //     path: "/harvard/" + carrierSpecificId
        //   });
        // } else {
        //   this.$router.push({
        //     //2奶妈百科
        //     path: "/baby/detail/" + carrierSpecificId
        //   });
        // }
      }

      this.$store.commit('saveAuidoTime', {
        id: '',
        time: 0,
        page: '',
      })

      switch (carrierId) {
          //种草社区
        case 12:
          this.$router.push({
            name: 'communityDetail',
            params: {
              id: carrierSpecificId,
            },
          })
          break
        case 1:
          this.$router.push({
            //1哈佛课堂
            path: '/harvard/' + carrierSpecificId,
          })
          break
        case 2:
          this.$router.push({
            //2奶妈百科
            path: '/baby/detail/' + carrierSpecificId,
          })
          break
        case 4:
          //4儿歌
          this.$router.push({
            name: 'parentchildsongsdetail',
            query: {
              id: carrierSpecificId,
            },
          })
          break
        case 5:
          //5音频
          this.$router.push({
            name: 'audiodetail',
            query: {
              id: carrierSpecificId,
              type: 'audio',
              disabled: 'disabled',
            },
          })
          break
        case 6:
          //6凯奇
          this.$router.push({
            name: 'audiodetail',
            query: {
              id: carrierSpecificId,
              type: 'cagechild',
              disabled: 'disabled',
            },
          })
          break
        case 7:
          //7辅食专栏
          this.$router.push({
            path: '/foodColumn/foodDetail/' + carrierSpecificId,
          })
          break
        case 10:
          this.getDoctorDetail(carrierSpecificId)
          //10京城名医
          // this.$router.push({
          //   path:'/bjdoctordetail',
          //   query:{
          //     id:carrierSpecificId
          //       }
          // })
          console.log(carrierSpecificId)
          break
      }
      // if (carrierId == 1) {
      //   this.getNewsState(id,this.userInfo.crm_id);
      //   this.$router.push({
      //     //1哈佛课堂
      //     path: "/harvard/" + carrierSpecificId
      //   });
      // } else {
      //   this.getReplyState(id);
      //   this.$router.push({
      //     //2奶妈百科
      //     path: "/baby/detail/" + carrierSpecificId
      //   });
      // }
    },
    // 点赞
    like(carrierId, carrierSpecificId, id, index, pid, crmId) {
      var nickName = this.getCookie('xmh_nickname')
      var headImg = this.getCookie('xmh_headimgurl')
      this.likeState = this.replyList[index].isLike
      console.log(this.replyList[index], 'this.replyList[index]')
      if (this.likeState) {
        // 取消赞
        if (carrierId == 12) {
          // console.log('取消赞种草社区', {
          //   id: this.replyList[index].id,
          //   // carrierId: carrierId,
          //   crmId: this.userInfo.crm_id,
          //   // type: '2',
          //   likeState: false,
          //   module: 1,
          //   itemId: this.replyList[index].carrierSpecificId,
          //   likeNum: 1,
          // })
          API.grassGrowingLike(
              {},
              {
                id: this.replyList[index].id,
                // carrierId: carrierId,
                crmId: this.userInfo.crm_id,
                // type: '2',
                likeState: false,
                module: 1,
                itemId: this.replyList[index].carrierSpecificId,
                likeNum: 1,
              },
              (res) => {
                if (res.code == 200) {
                  console.log('取消赞种草社区成功')
                  this.replyList[index].isLike = !this.likeState
                }
              }
          )
        } else {
          console.log('取消赞其他内容')
          API.cancelLike(
              {},
              {
                carrierId: carrierId,
                carrierSpecificId: carrierSpecificId,
                crmId: this.userInfo.crm_id,
                type: '3',
                isRead: false,
                parentId: pid,
                status: true,
                commentId: id,
                replyCrmId: crmId,
                sourceId: 4,
              },
              (res) => {
                if (res.code == 200) {
                  console.log('取消赞成功')
                  this.replyList[index].isLike = !this.likeState
                }
              }
          )
        }
      } else {
        // 点赞
        if (carrierId == 12) {
          console.log('点赞种草社区')
          API.grassGrowingLike(
              {},
              {
                id: this.replyList[index].id,
                // carrierId: carrierId,
                crmId: this.userInfo.crm_id,
                // type: '2',
                likeState: true,
                module: 1,
                itemId: this.replyList[index].carrierSpecificId,
                likeNum: 1,
              },
              (res) => {
                if (res.code == 200) {
                  console.log('点赞种草社区成功')
                  this.replyList[index].isLike = !this.likeState
                  this.getReplyState(id)
                  this.$toast({
                    duration: 2000,
                    message: '点赞成功',
                    context: this,
                  })
                }
              }
          )
        } else {
          console.log('点赞')
          API.onLike(
              {},
              {
                carrierId: carrierId,
                carrierSpecificId: carrierSpecificId,
                crmId: this.userInfo.crm_id,
                type: '3',
                isRead: false,
                parentId: pid,
                commentId: id,
                replyCrmId: crmId,
                status: true,
                nickName: nickName,
                headImg: headImg,
              },
              (res) => {
                if (res.code == 200) {
                  gio('track', 'informpage_likecomment')
                  this.replyList[index].isLike = !this.likeState
                  var type = carrierId == '1' ? 'spdz' + id : 'wzdz' + id
                  this.getReplyState(id)
                  this.$toast({
                    duration: 2000,
                    message: '点赞成功',
                    context: this,
                  })
                }
              }
          )
        }
      }
    },
    checkView(name) {
      if (name == 0) {
        gio('track', 'informpage_switchreplyplate')
        if (this.switchTagId == name) return false
        this.switchTagId = name
        this.replyListFinished = false
        this.replyListError = false
        this.replyListLoading = true
        this.replyList = []
        this.pageParams.page = 1
        this.getReplyList()
      } else if (name == 1) {
        gio('track', 'informpage_switchlikesplate')
        if (this.switchTagId == name) return false
        this.switchTagId = name
        this.likeListFinished = false
        this.likeListError = false
        this.likeListLoading = true
        this.likeList = []
        this.pagesParams.page = 1
        this.getLikeList()
      }
      this.showLikeNumber = false
    },
    goBack() {
      // this.$router.push({ path: '/home' })
      this.$router.go(-1)
    },
    replyComment(item) {
      gio('track', 'informpage_replycomment')
      this.replyUserInfo = item
      this.isFocus = true
      $('body').css('position', 'absolute')
      $('body').css('overflow', '')
    },
    isBlur(id) {
      if (id == '1') {
        $('body').css('position', 'initial')
        $('body').css('overflow', '')
        this.isFocus = false
      } else if (id == '2') {
      } else if (id == '3') {
      }
    },
    inputChange() {
      if (this.message.length >= 1) {
        $('.button').addClass('button2')
      } else if (this.message.length == 0) {
        $('.button').removeClass('button2')
      }
    },
    // 获取未读点赞数
    getCountLikes() {
      return new Promise((reslove) => {
        API.getCountLike({crmId: this.userInfo.crm_id}, {}, (res) => {
          if (res.code == 200) {
            this.countLikeNumber = res.data
            reslove(res.data)
            if (this.countLikeNumber && this.countLikeNumber > 0) {
              this.showLikeNumber = true
            }
            //   console.log(this.countLikeNumber);
          } else {
            console.error('请求异常')
          }
        })
      })
    },
    // 点赞更新消息状态
    getNewsState(ids, crmId) {
      API.getNewsState({id: ids, crmId: crmId}, (res) => {
      })
    },
    // 回复更新消息状态
    getReplyState(ids) {
      API.getReplyState({id: ids, crmId: this.userInfo.crm_id}, (res) => {
      })
    },
    // 获取回复信息列表
    async getReplyList() {
      console.log('恢复信息列表', this.userInfo.crm_id)
      let countLikes = await this.getCountLikes() //获取未读点赞数
      API.getReplyList(
          {},
          {
            data: {
              //TODO:测试id
              // crmId: 'CRM000000000042650980',
              crmId: this.userInfo.crm_id,
            },
            page: this.pageParams.page,
            size: this.pageParams.size,
          },
          (res) => {
            this.replyListLoading = false
            if (res.code == 200 && res.data) {
              console.log(res, 'res列表请求结果li')
              this.replyList = this.replyList.concat(res.data.replyMessages)
              this.replyNumber = res.data.unReadNum
              if (
                  this.replyNumber == 0 &&
                  countLikes != 0 &&
                  this.tabState == false
              ) {
                this.tabState = true
                this.showLikeNumber = false
                this.active = 1
              }
              if (this.replyList.length <= 0) {
                this.hideContent = false
                $('body').css({background: '#fff', 'font-size': '12px'})
              } else {
                $('body').css({background: '#f2f2f2', 'font-size': '12px'})
              }
              if (
                  this.pageParams.page >=
                  Math.ceil(res.data.total / this.pageParams.size) ||
                  Math.ceil(res.data.total / this.pageParams.size) <= 1
              ) {
                this.replyListFinished = true
                if (res.data.total >= 4) {
                  this.likeFnishText = '——已经到底了哦——'
                }
              } else {
                this.replyListFinished = false
                this.pageParams.page += 1
              }
            } else {
              this.replyListLoading = false
              this.replyListError = true
              console.error('请求异常')
            }
          }
      )
    },
    //获取点赞信息列表
    getLikeList() {
      API.getLikeList(
          {},
          {
            data: {
              crmId: this.userInfo.crm_id,
            },
            page: this.pagesParams.page,
            size: this.pagesParams.size,
          },
          (res) => {
            this.likeListLoading = false
            if (res.code == 200) {
              this.likeList = this.likeList.concat(res.data.list)
              if (this.likeList.length <= 0) {
                this.hideContents = false
                $('body').css({background: '#fff', 'font-size': '12px'})
              } else {
                $('body').css({background: '#f2f2f2', 'font-size': '12px'})
              }

              if (
                  this.pagesParams.page >=
                  Math.ceil(res.data.total / this.pagesParams.size) ||
                  Math.ceil(res.data.total / this.pagesParams.size) <= 1
              ) {
                this.likeListFinished = true
                if (res.data.total >= 4) {
                  this.likeFnishText = '——已经到底了哦——'
                }
              } else {
                this.likeListFinished = false
                this.pagesParams.page += 1
              }
            } else {
              this.likeListLoading = false
              this.likeListError = true
              console.error('请求异常')
            }
          }
      )
    },
    // 回复提交
    submitAllComment: Debounce(function () {
      this.isFocus = false
      let headImg = this.getCookie('xmh_headimgurl')
      let nickName = this.getCookie('xmh_nickname')
      let openid = this.getCookie('xmh_openid')
      if (this.flag) {
        this.flag = false
        if (this.replyUserInfo.carrierId == 12) {
          console.log('种草社区回复提交', {
            itemId: this.replyUserInfo.carrierSpecificId, //文章id，对应carrierSpecificId
            comments: this.replyUserInfo.carrierSpecificId, //评论内容，对应contents
            crmId: this.userInfo.crm_id,
            headImgUrl: headImg,
            userName: nickName, //用户昵称，对应nickName
            replyCrmId: this.replyUserInfo.crmId, //回复的评论用户crmId

            level: 2, //几级评论
            module: 1, //模块儿，种草社区为12
            parentId: this.replyUserInfo.pid,
          })
          API.grassGrowingSubmitComment(
              {},
              {
                // carrierId: this.replyUserInfo.carrierId,
                itemId: this.replyUserInfo.carrierSpecificId, //文章id，对应carrierSpecificId
                comments: this.message, //评论内容，对应contents
                crmId: this.userInfo.crm_id,
                headImgUrl: headImg,
                userName: nickName, //用户昵称，对应nickName
                replyCrmId: this.replyUserInfo.crmId, //回复的评论用户crmId
                // replyNickName: this.replyUserInfo.nickName,
                // replyHeadImg: this.replyUserInfo.headImg,
                level: 2, //几级评论

                module: 1, //模块儿，种草社区为12
                // commentId: this.replyUserInfo.id,
                parentId: this.replyUserInfo.pid,
                // contentId: this.replyUserInfo.carrierSpecificId, //先给空，看看能不能调用成功
                // openid: openid,
                // replyOpenId: this.replyUserInfo.openid,
              },
              (res) => {
                if (res.code == '200') {
                  this.getReplyState(this.replyUserInfo.id)
                  this.replyList = []
                  this.getReplyList()
                  this.message = ''
                  $('body').css('position', 'initial')
                  $('body').css('overflow', '')
                  var page = '1'
                  var size = '25'
                  var status = true
                  $('.button').removeClass('button2')
                  var relation =
                      this.replyUserInfo.carrierId == '1'
                          ? 'sphfej' + this.replyUserInfo.id
                          : 'wzhfej' + this.replyUserInfo.id
                  this.$toast({
                    duration: 2000,
                    message: '评论成功',
                    context: this,
                  })
                  setTimeout(() => {
                    this.flag = true
                  }, 1000)
                } else {
                  this.$toast('评论失败')
                }
              }
          )
        } else {
          console.log('其他内容回复提交')
          API.submitComment(
              {},
              {
                carrierId: this.replyUserInfo.carrierId,
                carrierSpecificId: this.replyUserInfo.carrierSpecificId,
                contents: this.message,
                crmId: this.userInfo.crm_id,
                headImg: headImg,
                nickName: nickName,
                replyCrmId: this.replyUserInfo.crmId,
                replyNickName: this.replyUserInfo.nickName,
                replyHeadImg: this.replyUserInfo.headImg,
                commentType: '2',
                commentId: this.replyUserInfo.id,
                parentId: this.replyUserInfo.pid,
                openid: openid,
                replyOpenId: this.replyUserInfo.openid,
              },
              (res) => {
                if (res.code == '200') {
                  this.getReplyState(this.replyUserInfo.id)
                  this.replyList = []
                  this.getReplyList()
                  this.message = ''
                  $('body').css('position', 'initial')
                  $('body').css('overflow', '')
                  var page = '1'
                  var size = '25'
                  var status = true
                  $('.button').removeClass('button2')
                  var relation =
                      this.replyUserInfo.carrierId == '1'
                          ? 'sphfej' + this.replyUserInfo.id
                          : 'wzhfej' + this.replyUserInfo.id
                  this.$toast({
                    duration: 2000,
                    message: '评论成功',
                    context: this,
                  })
                  setTimeout(() => {
                    this.flag = true
                  }, 1000)
                } else {
                  this.$toast('评论失败')
                }
              }
          )
        }
      }
    }, 500),
  },
}
</script>

<style lang="less" scoped>
@import '../../../assets/less/harvard.less';
</style>
